
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/demo/codeDemo/tokenizer.md?watch=parent';
    export const toc = [{"id":"zh-cn","depth":2,"title":"zh-CN"},{"id":"en-us","depth":2,"title":"en-US"}];
export const frontmatter = {"title":"Tokenizer","toc":"menu","filename":"docs/x-markdown/demo/codeDemo/tokenizer.md","lastUpdated":1763781754000,"description":"使用 tokenizer 设置 % 作为标题渲染。"};